export default __webpack_public_path__ + "static/media/fintech.74c93262.jpg";